//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.RoughFinishTurningBuilder.js";
import "../CAM/CAM.TurnBiTangentSmoothing.js";
import "../CAM/CAM.CutStrategy.js";
import "../CAM/CAM.TurnDirection.js";
import "../CAM/CAM.FirstPlunge.js";
import "../CAM/CAM.TurnNcmSmoothing.js";
import "../CAM/CAM.TurnNcmTransferWithinRegions.js";
import "../CAM/CAM.NcmTurnRoughBuilder.js";
import "../CAM/CAM.PostEventsCiBuilder.js";
import "../CAM/CAM.StepoverBuilder.js";
let d=[[[1,"BiTangentSmoothingBuilder",0,"CAM.TurnBiTangentSmoothing",0],[0,"Cleanup",1,0],[1,"CutStrategy",0,"CAM.CutStrategy",0],[1,"Direction",0,"CAM.TurnDirection",0],[1,"FirstPlunge",0,"CAM.FirstPlunge",0],[0,"LevelDepth",1,0],[0,"LevelDepthMode",1,0],[1,"NcmSmoothingBuilder",0,"CAM.TurnNcmSmoothing",0],[1,"NcmTransferWithinRegionsBuilder",0,"CAM.TurnNcmTransferWithinRegions",0],[1,"NonCuttingBuilder",0,"CAM.NcmTurnRoughBuilder",0],[0,"PartOffDepthMode",1,0],[0,"PartOffDepthValue",1,0],[1,"PartOffEvents",0,"CAM.PostEventsCiBuilder",0],[0,"PartOffPositionMode",1,0],[0,"PartOffPositionPoint",1,"Point",0],[0,"ReversalMode",1,0],[0,"SafeDistance",1,0],[1,"Stepover",0,"CAM.StepoverBuilder",0]],[],[]];
SPLM.CAM.RoughTurningBuilder = class extends SPLM.CAM.RoughFinishTurningBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.RoughTurningBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.RoughTurningBuilder.PartOffPositionModeTypes = Object.freeze({
    "Automatic" : "Automatic", "Specify" : "Specify"});

SPLM.CAM.RoughTurningBuilder.PartOffDepthModeTypes = Object.freeze({
    "Divide" : "Divide", "CleanFirstWall" : "CleanFirstWall", "CleanBothWalls" : "CleanBothWalls", "Stock" : "Stock", "Distance" : "Distance"});

SPLM.CAM.RoughTurningBuilder.ReversalModeTypes = Object.freeze({
    "AsLevel" : "AsLevel", "Inverse" : "Inverse", "Closest" : "Closest", "CutLater" : "CutLater", "Omit" : "Omit"});

SPLM.CAM.RoughTurningBuilder.CleanupTypes = Object.freeze({
    "None" : "None", "All" : "All", "SteepOnly" : "SteepOnly", "AllButSteep" : "AllButSteep", "LevelOnly" : "LevelOnly", "AllButLevel" : "AllButLevel", "DownOnly" : "DownOnly", "PerReversal" : "PerReversal"});

SPLM.CAM.RoughTurningBuilder.LevelDepthModeTypes = Object.freeze({
    "FromTool" : "FromTool", "Specify" : "Specify"});

export default SPLM;